const familyTypesColumns = {
  familyCode: {
    key: 'familyCode',
    label: 'familyCode',
    type: 'text',
  },
  family: {
    key: 'family',
    label: 'family',
    type: 'text',
  },
  type: {
    key: 'type',
    label: 'type',
    type: 'text',
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    buttons: [
      {
        name: 'editFamilyType',
        icon: 'fas fa-pencil',
        permissions: ['familyTypeManage'],
      },
    ],
  },
};

export default familyTypesColumns;
